import {createStore, combineReducers, applyMiddleware, compose} from "redux";
import {useDispatch, useSelector} from 'react-redux'
import {authReducer} from "./modules/auth.ts";
import {globalReducer} from "./modules/global.ts";
import {thunk} from 'redux-thunk'
import {searchReducer} from "config/store/modules/search.ts";
import {adminReducer} from "config/store/modules/admin.ts";


const middlewares = compose(applyMiddleware(thunk))
const reducers = combineReducers({
    auth: authReducer,
    global: globalReducer,
    search: searchReducer,
    admin: adminReducer
})

// @ts-ignore
const store = createStore(reducers, undefined, middlewares)


// Infer the `RootState` and `AppDispatch` types from the store itself
type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
type AppDispatch = typeof store.dispatch

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()

export default store;
